import React from 'react'
import styled from '@emotion/styled'

export default () => {
  return <Loading />
}

const Loading = () => <LoadingHeader>...</LoadingHeader>

const LoadingHeader = styled.header`
  background-color: white;
  width: 100%;
  height: 58px;
`
